var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"allSetting"},[_c('loading-overlay',{attrs:{"active":_vm.isLoading}}),_c('AppHeader'),_c('AppSideBar'),_c('div',{staticClass:"paddingControl"},[_c('router-view'),_c('LoginPage'),_c('AppFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }